/*
 * Los QR del modo totem: el enlace a nuestra propia web y su imagen.
 *
 * La imagen la pinta el gestor (/external/qr), que solo acepta direcciones de
 * nuestras webs: la web no tiene libreria de QR.
 *
 * El enlace sale del origen en el que se esta, y no de una direccion escrita
 * aqui, para que el de Barcelona lleve a la web de Barcelona.
 */
export const enlaceDeLaWeb = (parametros, ruta = '/') => {
  const enlace = new URL(window.location.origin + ruta)
  for (const [clave, valor] of Object.entries(parametros)) {
    if (valor !== null && valor !== undefined && valor !== '') {
      enlace.searchParams.set(clave, String(valor))
    }
  }
  return enlace.toString()
}

export const imagenDelQr = (enlace) =>
  process.env.VUE_APP_PATH + 'qr?texto=' + encodeURIComponent(enlace)
